<template>
    <div>
        <div>
            <b-form-group
                :description="$t('forms.notification-disable-description')">
                <label class="typo__label">Select Method</label>
                <multiselect v-model="disableNotificationsTypeSelected"
                             track-by="value"
                             :close-on-select="true"
                             :show-labels="false"
                             label="text"
                             placeholder="Select one"
                             :options="disableNotificationsTypeOptions"
                             :searchable="false"
                             :allow-empty="false">
                </multiselect>
            </b-form-group>
            <b-button variant="success" class="w-100" v-on:click="sendDisableNotificationsCommand">{{ $t('forms.disable-notifications') }}</b-button>
        </div>
    </div>
</template>

<script>
/*
DISABLE_HOST_NOTIFICATIONS
DISABLE_HOST_SVC_NOTIFICATIONS
ENABLE_HOST_NOTIFICATIONS
ENABLE_HOST_SVC_NOTIFICATIONS
 */
import Multiselect from "vue-multiselect";
import { useToast } from "vue-toastification";

export default {
    name: "HostNotifications",
    components: {Multiselect},
    data(){
        return {
            disableNotificationsTypeSelected: {
                value: 'hostOnly',
                text: this.$t('hosts.individual')
            },
            disableNotificationsTypeOptions: [
                {
                    value: 'hostOnly',
                    text: this.$t('hosts.individual')
                },
                {
                    value: 'hostAndServices',
                    text: this.$t('hosts.including-services')
                }
            ],
        }
    },
    props: [
        'hostids',
    ],
    methods: {
        sendDisableNotificationsCommand: function(){
            if(this.hostids.length === 0){
                useToast().error('no hosts selected', {
                    timeout: 2000
                });
                return;
            }

            let externalCommand = []
            for(let host in this.hostids){
                externalCommand.push({
                  //  command: 'DISABLE_HOST_NOTIFICATIONS',
                  //  hostUuid: this.hostids[host].hostUuid,
                    command: 'submitDisableHostNotifications',
                    hostUuid: this.hostids[host].hostUuid,
                    type:  this.disableNotificationsTypeSelected.value
                })
            }

            this.sendCommand(externalCommand);

        },
        sendCommand: function(externalCommand){
            axios.post('/hosts/external_commands.json', externalCommand)
                .then(response => {
                        if(response.data.response.code && response.data.response.code === 403) {
                            useToast().error('insufficient rights', {
                                timeout: 2000
                            });
                        } else {
                            useToast().success(this.$t('Command successfully sent'), {
                                timeout: 7000
                            });
                        }
                        this.$emit('refresh')
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },
    },
}
</script>

<style scoped>

</style>
